const KEY = "my-library-books";

export function loadBooks() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.warn("Failed to load books from storage", err);
    return null;
  }
}

export function saveBooks(booksArray) {
  try {
    localStorage.setItem(KEY, JSON.stringify(booksArray));
  } catch (err) {
    console.warn("Failed to save books to storage", err);
  }
}

